export enum UserOrderingGroup {
  New = 'New',
  Featured = 'Featured',
  TopRated = 'TopRated',
}
